import * as React from 'react';
import BasicSelect from './BasicSelect.jsx';
import Label from './Label.jsx';
import ResponsiveDateRangePicker from './ResponsiveDateRangePicker.jsx';
import { ThemeProvider } from '@mui/material/styles';
import { backYouTheme } from '../../../../theme';

export default function SelectDateSimple(props) {
  const { 
    slug, 
    label, 
    items,
    selectedItems, 
    autoTrad, 
    parentFunction, 
    custom = false
  } = props;

  return (
    <ThemeProvider theme={backYouTheme}>
      <Label htmlForValue={"select-date-simple"} label={label}/>
      <div className="row">
        <div className="col-12">
          <BasicSelect slug={slug} items={items} selectedItems={selectedItems} autoTrad={autoTrad} parentFunction={parentFunction}/>
        </div>
        {
          custom &&
          <div className="col-12 mt-2">
            <ResponsiveDateRangePicker parentFunction={parentFunction}/>  
          </div>
        }
      </div>
    </ThemeProvider>
  );
}